<template>
<CRow>
<CDataTable
    class="col-12 px-0"
    :items="Object.values(commissions)"
    :fields="$dataTableFieldsMaker(fields)"
    hover
    :pagination="{...pagination, change: fetchCommissions}"
    addTableClasses="bg-white"
>
    <template #name="{item}">
        <td>
            <span
                class="d-inline-block mfe-2"
                style="border-radius:50%;width:10px;height:10px;"
                :class="item.status === CommissionStatus.ACTIVE ? 'bg-success' : 'bg-danger'"
                v-if="$policy('commission', item).create"
            ></span>
            {{ item.name }}
        </td>
    </template>
    <template #conversionType="{item}">
        <td>
            {{ conversionTypeStr(item.conversion_type) }}
        </td>
    </template>

    <template #benefit="{item}">
        <td>
            {{ item.type ===  0
                ? item.benefit +' '+ $t('percent') : $numberWithCommas(item.benefit) +' '+ $t('rial')
            }}

            <span v-if="item.limit !== null" class="d-block w-fit-content badge badge-primary p-2">
                {{ $t('commission.with_limit_brif') }} {{ $numberWithCommas(item.limit) }} {{ $t('rial') }}
            </span>
        </td>
    </template>

    <template #store="{item}">
        <td>
            {{ item.store.name || '---' }}
        </td>
    </template>

    <template #actions="{item}">
        <td>
            <router-link class="px-1" v-if="$policy('commission').edit" :to="{name: 'commissions.edit', params: {id: item.id}}">
                <FaIcon icon="edit" />
            </router-link>
            <!-- <CLink class="px-1" @click="modal = {show: true, item: item}" v-if="$policy('commission').soft_delete">
                <FaIcon icon="trash" class="text-danger"/>
            </CLink> -->
        </td>
    </template>
</CDataTable>

<CModal v-if="modal.show" :title="$t('commission.delete')" color="danger" :show.sync="modal.show">
    {{ $t('commission.are_you_sure_to_remove', { attribute: modal.item.title }) }}
    <template #footer>
        <CButton @click="modal.show = false" color="secondary">
            {{ $t('cancel') }}
        </CButton>
        <CButton @click="deleteModal" color="danger">
            {{ $t('delete') }}
        </CButton>
    </template>
</CModal>
</CRow>
</template>

<script>
import fields from './fields'
import { mapActions, mapGetters } from 'vuex'
import { CommissionStatus } from '@/constants'
import { conversionTypeStr, statusColor, statusStr } from './methods'

export default {
    name: 'Table',

    data() {
        return {
            fields,
            modal: {
                show: false,
                item: {}
            },
            CommissionStatus
        }
    },

    computed: {
        ...mapGetters({
            commissions: 'commission/commissions',
            pagination: 'commission/pagination'
        }),
    },

    methods: {
        ...mapActions({
            fetch: 'commission/fetch',
            // deleteCommission: 'commission/delete',
        }),
        conversionTypeStr,
        statusColor,
        statusStr,
        fetchCommissions(activePage = 1) {
            this.fetch({
                page: activePage,
            })
        },
        // deleteModal() {
        //     this.deleteCommission(this.modal.item.id).then(() => this.modal.show = false)
        // },
    }
}
</script>

<style lang="scss" scoped>
::v-deep .table td {
    vertical-align: middle;
}
</style>